import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI = 'ppis';

export default class PPIService extends SfpBaseService {
    static findAllPPIs() {
        return fetch(`${apiBaseUrl}/${PPI}`, {headers: getBaseHeader()})
            .then(super.returnResponse);
    }

    static createPPI(ppi) {
        const body = JSON.stringify({ppi});
        const headers = {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        };

        return fetch(`${apiBaseUrl}/${PPI}`, {body, headers, method: "POST"})
            .then(super.returnResponse);
    }

    static findPPIByLAId(LAId) {
        return fetch(`${apiBaseUrl}/${PPI}/${LAId}`, {headers: getBaseHeader()})
            .then(super.returnResponse);
    }

    static addYear(ppi_id) {
        const headers = {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        };

        return fetch(`${apiBaseUrl}/${PPI}/${ppi_id}/add-year`, {headers, method: "PUT"})
            .then(super.returnResponse);
    }

    static deleteLastYear(ppi_id) {
        const headers = {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        };

        return fetch(`${apiBaseUrl}/${PPI}/${ppi_id}/delete-last-year`, {headers, method: "DELETE"})
            .then(super.returnResponse);

    }
}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-service.js